/**
 * Trace ID utilities for request correlation across frontend and backend.
 * Use trace_id to correlate logs and API requests in Datadog.
 */

export function generateTraceId(): string {
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    const values = new Uint8Array(16)
    crypto.getRandomValues(values)
    return Array.from(values, (value) => value.toString(16).padStart(2, "0")).join("")
  }
  return Array.from({ length: 4 }, () =>
    Math.floor(Math.random() * 0x100000000)
      .toString(16)
      .padStart(8, "0")
  ).join("")
}
